import React from 'react';
import { Rows3Icon, Rows4Icon } from 'lucide-react';
import { SearchField } from '../ui/SearchField';
import { ColumnsMenu } from './ColumnsMenu';
import { GroupByMenu } from './GroupByMenu';
import { ShortcutsMenu } from './ShortcutsMenu';

const densities = [
  { value: 'comfortable', icon: Rows3Icon, label: 'Expanded rows' },
  { value: 'compact', icon: Rows4Icon, label: 'Condensed rows' },
];

export function TableToolbar(props) {
  const {
    viewsMenu, searchRef, search, onSearchChange, resultCount, groupBy, onGroupByChange, density, onDensityChange,
    orderedKeys, visibleKeys, meta, isLayoutCustomized, onToggleColumn, onShowAllColumns, onHideAllColumns, onResetLayout,
  } = props;

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-border-b tw-border-neutral-200 tw-px-5 tw-py-3">
      {viewsMenu}
      <SearchField
        inputRef={searchRef}
        value={search}
        onChange={onSearchChange}
        placeholder="Search participant, guardian, booking #, phone, email…"
        label="Search registrations"
        shortcutHint="/"
        className="tw-w-full sm:tw-w-80"
      />
      <div className="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <span className="tw-whitespace-nowrap tw-text-sm tw-text-neutral-500" aria-live="polite">
          <span className="tw-font-medium tw-tabular-nums tw-text-neutral-900">{resultCount}</span> {resultCount === 1 ? 'result' : 'results'}
        </span>
        <GroupByMenu value={groupBy} onChange={onGroupByChange} />
        <div role="radiogroup" aria-label="Row density" className="tw-flex tw-h-9 tw-items-center tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-p-0.5">
          {densities.map(({ value, icon: Icon, label }) => (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={density === value}
              aria-label={label}
              title={label}
              onClick={() => onDensityChange(value)}
              className={`tw-flex tw-h-full tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-transition-colors tw-duration-150 ${density === value ? 'tw-bg-brand-50 tw-text-brand-600' : 'tw-text-neutral-400 hover:tw-text-neutral-900'}`}>
              <Icon className="tw-h-4 tw-w-4" />
            </button>
          ))}
        </div>
        <ColumnsMenu
          orderedKeys={orderedKeys}
          visibleKeys={visibleKeys}
          lockedKeys={['participant']}
          meta={meta}
          isCustomized={isLayoutCustomized}
          onToggle={onToggleColumn}
          onSelectAll={onShowAllColumns}
          onDeselectAll={onHideAllColumns}
          onResetLayout={onResetLayout}
        />
        <ShortcutsMenu />
      </div>
    </div>
  );
}
